import { register } from '@shopify/theme-sections'
import { Carousel } from '../modules/carousel'

import '../../styles/sections/index-icons-links.scss'

export default register(`index-icons-links`, {
  onLoad() {
    Carousel()
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})

